class CommonProperties {
    constructor(Created, Description, Color) {
        this.Created = Created || Date.now();
        this.Description = Description;
        this.Color = Color;
    }
}
export default CommonProperties;
